import { useContext } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { IBusinessCollectionProps } from '../../../../../../Types/ObjektVy';
import { TEDLRBetalningSTATUSEnum } from '../../../../../../globalQueryTypes';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { includes } from 'ramda';
import {
  BetalningQuery as BetalningQueryData,
  BetalningQueryVariables,
} from './Queries/_QueryTypes/BetalningQuery';
import BetalningQuery from './Queries/BetalningQuery.gql';
import SparraBetalningMutation from './Mutations/SpärraBetalningMutation.gql';
import {
  SparraBetalningMutation as SparraBetalningMutationData,
  SparraBetalningMutationVariables,
} from './Mutations/_QueryTypes/SparraBetalningMutation';
import {
  definedSelectedId,
  selectedId,
} from '../../../../../../Components/MasterDetail/MasterDetailUtils';

interface IReturnValue {
  mutate: () => void;
  disabled: boolean;
}

export const useSparraBetalning = (
  input: IBusinessCollectionProps
): IReturnValue => {
  const id = input.id;
  const activeDatabase = useContext(ActiveDatabaseContext).activeDatabase;

  const queryResult = useQuery<BetalningQueryData, BetalningQueryVariables>(
    BetalningQuery,
    {
      variables: { ID: selectedId(id) || '' },
      skip: !id,
    }
  );

  const node =
    queryResult?.data?.node?.__typename === 'TEDLRBetalning'
      ? queryResult?.data?.node
      : null;
  const version = node?._version;

  const mutationVariables: SparraBetalningMutationVariables | undefined =
    node != null &&
    node.__typename === 'TEDLRBetalning' &&
    id != null &&
    activeDatabase != null &&
    version != null
      ? {
          id: definedSelectedId(id),
          db: activeDatabase,
          version: version,
        }
      : undefined;

  const [spärraBetalningMutationFn] = useMutation<
    SparraBetalningMutationData,
    SparraBetalningMutationVariables
  >(SparraBetalningMutation, {
    variables: mutationVariables,
  });

  const disabled =
    mutationVariables == null ||
    !includes(node?.STATUS, [
      TEDLRBetalningSTATUSEnum.ANKOMSTREGISTRERAD,
      TEDLRBetalningSTATUSEnum.DEFINITIVBOKAD,
    ]);

  return { mutate: spärraBetalningMutationFn, disabled };
};
